import { Meeting as ApiMeeting } from "../api/meetings";
import { Host } from "./host";
import {
  MeetingHostSchedule,
  fromApiHostSchedule,
} from "./meeting_host_schedule";

export interface InstanceMetadata {
  meetingType?: string;
  host?: Host;
  memberVisible: boolean;
  // Continuous room grouping key — see api/meetings.ts InstanceMetadata.
  continuousRoomKey?: string;
  /**
   * Partner scope. Authored on the calendar event, like memberVisible, so the
   * sync stamps it onto every occurrence a recurring series produces — the
   * only way a "make the whole series private" choice can reach occurrences
   * that do not exist yet. Empty string clears it.
   */
  partnerId?: string;
}

export interface RecurringMetadata {
  meetingType?: string;
  memberVisible?: boolean;
  hostSchedule?: MeetingHostSchedule;
  continuousRoomKey?: string;
  /** See InstanceMetadata.partnerId — set on the series master. */
  partnerId?: string;
}

export const instanceFromApiMeeting = (
  apiMeeting: ApiMeeting,
  hostsById: Record<string, Host>
): InstanceMetadata => {
  return {
    meetingType: apiMeeting.metadata.meetingType,
    host: apiMeeting.metadata.hostId
      ? hostsById[apiMeeting.metadata.hostId]
      : undefined,
    memberVisible: apiMeeting.metadata.memberVisible ?? false,
    continuousRoomKey: apiMeeting.metadata.continuousRoomKey,
    partnerId: apiMeeting.metadata.partnerId,
  };
};

export const recurringFromApiMeeting = (
  apiMeeting: ApiMeeting,
  hostsById: Record<string, Host>
): RecurringMetadata | undefined => {
  if (!apiMeeting.recurringMeeting) {
    return undefined;
  }
  const apiMetadata = apiMeeting.recurringMeeting.metadata;
  return {
    meetingType: apiMetadata.meetingType,
    hostSchedule: fromApiHostSchedule(apiMetadata.hostSchedule, hostsById),
    memberVisible: apiMetadata.memberVisible ?? false,
    continuousRoomKey: apiMetadata.continuousRoomKey,
    partnerId: apiMetadata.partnerId,
  };
};
